import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { CookieConsentBanner } from '@/features/analytics/CookieConsentBanner';
import { getConsent } from '@/features/analytics/cookies';
import { flushCurrentPage, trackPageview } from '@/features/analytics/tracker';
import { isNativeApp } from '@/lib/nativeApp';

/**
 * Bandeau cookies + suivi de parcours (pageviews / durée / UTM).
 * Branché sous BrowserRouter pour accéder à useLocation.
 */
export function AnalyticsRoot() {
  const location = useLocation();
  const startedRef = useRef(false);

  useEffect(() => {
    if (isNativeApp()) return;
    if (getConsent() !== 'accepted') return;
    trackPageview(location.pathname, location.search);
    startedRef.current = true;
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (isNativeApp()) return;
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') flushCurrentPage();
    };
    const onPageHide = () => flushCurrentPage();
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', onPageHide);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', onPageHide);
    };
  }, []);

  if (isNativeApp()) return null;

  return (
    <CookieConsentBanner
      onChange={(choice) => {
        if (choice === 'accepted') {
          trackPageview(location.pathname, location.search);
          startedRef.current = true;
        }
      }}
    />
  );
}
